import "./agile-rotating-takeover.scss";

import { DialogController } from "aurelia-dialog";
import { autoinject, computedFrom } from "aurelia-framework";

import nameof from "../../common/nameof";
import { UsersService } from "../../services/users-service";

@autoinject
export class AgileRotatingTakeover {
    private readonly _dialogController: DialogController;
    private readonly _usersService: UsersService;
    public agileUrl: string = "https://www.axxess.com/agile/register?promo=AXXESSCLIENT";
    public agileTakeoverSrcs = [
        require("../../assets/images/agile_takeover_1.png"),
        require("../../assets/images/agile_takeover_2.png"),
        require("../../assets/images/agile_takeover_3.png"),
        require("../../assets/images/agile_takeover_4.png"),
        require("../../assets/images/agile_takeover_5.png")
    ];
    public takeoverIndex: number;

    @computedFrom(nameof<IAgileTakeoverPromptOptions>("takeoverIndex"))
    public get agileTakeoverUrl() {
        if (this.takeoverIndex >= 0 && this.takeoverIndex < this.agileTakeoverSrcs.length) {
            return this.agileTakeoverSrcs[this.takeoverIndex];
        }
        // In case index goes out of range, display first image
        return this.agileTakeoverSrcs[0];
    }

    public constructor(dialogController: DialogController, usersService: UsersService) {
        this._dialogController = dialogController;
        this._usersService = usersService;
    }

    public activate(params: IAgileTakeoverPromptOptions) {
        this.takeoverIndex = params.takeoverIndex;
    }

    public closeDialogBox() {
        window.open(this.agileUrl);
        this._dialogController.close(true);
    }

    public closeWithoutRerouting() {
        this._dialogController.close(true);
    }

    public async canDeactivate() {
        try {
            await this._usersService.updateAgileRotatingTakeover({ hasShownAgileTakeover: true });
        } catch (error) {
            console.error(error);
        }
    }
}

export interface IAgileTakeoverPromptOptions {
    takeoverIndex: number;
}